/**
 * Subdomain validation and formatting utilities
 */

/**
 * Generates a URL-safe subdomain preview from business name
 * - Converts to lowercase
 * - Removes special characters (keeps only a-z, 0-9)
 * - Removes spaces and special characters
 * - Max length: 63 characters
 * @param businessName - Business name to convert to subdomain
 * @returns Formatted subdomain preview
 */
export function getSubdomainPreview(businessName?: string): string {
  if (!businessName) return '';
  
  return businessName
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
    .substring(0, 63);
}

/**
 * Validates and sanitizes subdomain format
 * - Converts to lowercase
 * - Removes invalid characters (keeps only a-z, 0-9)
 * - Max length: 63 characters
 * @param subdomain - Subdomain to validate
 * @returns Cleaned subdomain
 */
export function validateSubdomainFormat(subdomain?: string): string {
  if (!subdomain) return '';

  return subdomain
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
    .substring(0, 63);
}
